import { percentClient } from '@percent/admin-dashboard/common/HOC/withAxios/WithAxios'

export const capabilities = {
  percentClient
}

export type Capabilities = typeof capabilities
